<router-outlet></router-outlet>
<cc-list-tool-bar
  [selectedItemIds]="state.selectedListIds"
  [canDeployLists]="canDeployLists"
  (archiveSelectedItems)="onListsArchived(state.selectedListIds)"
  (restoreSelectedItems)="onListsRestored(state.selectedListIds)"
  (deleteSelectedItems)="onListsDelete(state.selectedListIds)"
  (createNewItem)="onSelectList('new')"
>
</cc-list-tool-bar>

<div class="scrollable" *ngIf="!state.isLoading; else loadingState">
  <!-- Display records state -->
  <ng-container *ngIf="lists.length; else empty">
    <div
      class="container px-4 pt-4"
      [class.w-100]="lists.length < fullDisplayMode"
      [class.px-lg-0]="lists.length >= fullDisplayMode"
      [class.mx-lg-auto]="lists.length >= fullDisplayMode"
    >
      <cc-list-thumbnail
        class="mb-4 mr-sm-4"
        *ngFor="let list of lists"
        [list]="list"
        [listIsDeployed]="list.deployedParents?.includes(parentId)"
        [selected]="state.selectedListIds.includes(list.id)"
        (selectList)="onSelectList($event)"
        (changeSelectedState)="onChangeSelectedState($event.listId, $event.selected)"
      >
      </cc-list-thumbnail>
    </div>
  </ng-container>

  <!-- No records state -->
  <ng-template #empty>
    <cc-lists-grid-empty-state></cc-lists-grid-empty-state>
  </ng-template>
</div>

<!-- Loading state -->
<ng-template #loadingState>
  <div class="loading-spinner interim-state">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>
